package org.matthewo.pages

import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import js.coroutines.awaitCancellation
import kotlinx.coroutines.launch
import org.matthewo.YEAR_PARAM
import org.matthewo.api.EventCompetition
import org.matthewo.api.MetricsAPI
import org.matthewo.client
import org.matthewo.hooks.useCoroutineScope
import org.matthewo.routes.API
import org.matthewo.schema.ALL_YEARS
import org.matthewo.table.RecordsTableSort
import org.matthewo.table.games.RecordsTableGeneric
import org.matthewo.useDefaultHeader
import org.matthewo.useLoading
import react.FC
import react.useEffect
import react.useMemo
import react.useState
import tanstack.react.router.useParams

val GameRecordsTable = FC("GameRecordsTable") {
    useDefaultHeader(ALL_YEARS)

    val coroutineScope = useCoroutineScope()
    val pathParams = useParams()

    val year = pathParams[YEAR_PARAM]?.toIntOrNull()

    var data by useState<Pair<Int, List<EventCompetition<Short, MetricsAPI<Short>>>?>>((year ?: -1) to null)

    var query by useState<RecordsTableSort.StatMatric<Short, *>>()

    useMemo(year) {
        val year = year ?: return@useMemo
        data = year to null
    }

    useLoading(null == data.second)

    useEffect(year, query) {
        val year = year ?: return@useEffect
        val q = query
        if (null != q) {
            val job = coroutineScope.launch {
                val response = client.get(API.Year.Records(year, q.stat.name, q.metric.name, q.order == DESCENDING))
                data = year to response.body<List<EventCompetition<Short, MetricsAPI<Short>>>>()
            }
            awaitCancellation { job.cancel() }
        }
    }

    RecordsTableGeneric(data.first, data.second) {
        sortableByTeam = false
        onSort = { sorting ->
            query = sorting
            data = data.first to null
        }
        showNew = true
    }
}
